import React from 'react';
import Breadcrumbs from 'components/partials/beadcrumbs/breadcrumbs';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

interface BreadcrumbData {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface HeroContentTypeProps {
  title?: string;
  description?: string;
  breadcrumbs?: BreadcrumbData[];
  customClass?: string;
}

const HeroContentType = ({
  title = '',
  description = '',
  breadcrumbs = [],
  customClass = '',
}: HeroContentTypeProps): React.JSX.Element => (
  <div
    className={`bg-navy-50 flex flex-col w-full items-center pb-16 ${customClass}`}
  >
    <ResponsiveWrapper customClass="flex flex-col">
      <div className="tablet:w-[600px]">
        <Breadcrumbs breadcrumbs={breadcrumbs} customClass="!mt-0 mb-9" />
        <div>
          <h1 className="text-5xl font-semibold text-navy-800 mb-4">
            {title}
          </h1>
          <div className="mobile:text-lg tablet:text-xl font-normal text-navy-800 mb-4">
            {description}
          </div>
        </div>
      </div>
    </ResponsiveWrapper>
  </div>
);

export default HeroContentType;
